import Joi from '@hapi/joi';
import errorMessages from '../assets/errorMessages';

export const isPhoneMaskValid = phoneNumber => /([2-9]\d{2}-[2-9]\d{2}-\d{4})/.test(phoneNumber);

export const isFormStateValid = formState => !(formState.hasSubmitErrors || formState.hasValidationErrors);

export const checkPasswordComplexity = password => {
  if (password.length < 8) {
    return false;
  }

  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);

  return hasUpperCase && hasLowerCase && hasNumbers === true;
};

export const getPasswordsValidationErrors = (values, passwordFieldName, passwordConfirmationFieldName) => {
  const errors = {};
  
  if (!values[passwordFieldName]) {
    errors[passwordFieldName] = 'Required';
  }
  
  if (!values[passwordConfirmationFieldName]) {
    errors[passwordConfirmationFieldName] = 'Required';
  }
  
  if (values[passwordFieldName] && !checkPasswordComplexity(values[passwordFieldName])) {
    errors[passwordFieldName] = 'Password is too weak';
  }
  
  if (
    values[passwordFieldName]
    && values[passwordConfirmationFieldName]
    && values[passwordFieldName] !== values[passwordConfirmationFieldName]
  ) {
    errors[passwordConfirmationFieldName] = 'Password mismatch!';
  }
  
  return errors;
};

export const isEmailValid = email => {
  const { error } = Joi
    .object()
    .keys({ email: Joi.string().email({ tlds: { allow: false } }) })
    .validate({ email: email });
  return !error;
};

export const REPLY_TO_ERRORS = {
  LOOKALIKE: 'Must be a valid @foodrescue.us address',
  NOT_ALLOWED: 'Must be a @foodrescue.us address, the site\'s reply-to address or your own email',
};

// RES-4875: the reply-to can be any foodrescue.us address, the site's reply-to address or the sender's own email, the
// api rejects anything else. the email sender lambda sends from a reply-to containing "@foodrescue.us", so it has to
// be on exactly that domain, and lookalikes such as foo@foodrescue.us.evil.com get their own message
export const getReplyToError = (replyTo, { siteReplyTo, senderEmail }) => {
  const normalize = email => `${email || ''}`.trim().toLowerCase();
  const normalizedReplyTo = normalize(replyTo);

  if (!isEmailValid(normalizedReplyTo)) {
    return errorMessages.ERR_INVALID_EMAIL.message;
  }

  if (normalizedReplyTo.includes('@foodrescue.us')) {
    return /^[^\s@]+@foodrescue\.us$/.test(normalizedReplyTo) ? undefined : REPLY_TO_ERRORS.LOOKALIKE;
  }

  const allowedReplyTos = [siteReplyTo, senderEmail].filter(Boolean).map(normalize);

  return allowedReplyTos.includes(normalizedReplyTo) ? undefined : REPLY_TO_ERRORS.NOT_ALLOWED;
};

export const isFormFieldInvalid = meta =>
  ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error || (meta.data && meta.data.error)) &&
  (meta.touched || (meta.data && meta.data.touched));

export const getFormFieldError = meta => meta.error || meta.submitError || (meta.data && meta.data.error) || null;
